import { gql } from "@apollo/client";
import County from "../fragments/County";

const FETCH_COUNTIES = gql`
  query FetchCounties {
    counties {
      ${County}
    }
  }
`;

const FETCH_COUNTIES_BY_COUNTRY = gql`
  query FetchCountiesByCountry($countryId: Int!) {
    countiesByCountry(countryId: $countryId) {
      ${County}
    }
  }
`;

export { FETCH_COUNTIES, FETCH_COUNTIES_BY_COUNTRY };
